import {
  ADD_ITEM_TO_STATES_LIST,
  REMOVE_ITEM_FROM_STATES_LIST,
  CLEAR_STATES_LIST,
} from "../types";

export const addStatesItem = (item) => ({
  type: ADD_ITEM_TO_STATES_LIST,
  stateData: item,
});

export const removeStatesItem = (item) => ({
  type: REMOVE_ITEM_FROM_STATES_LIST,
  stateData: item,
});

export const clearStatesItems = () => ({
  type: CLEAR_STATES_LIST,
});

export const addItemToStates = (item) => (dispatch) => {
  dispatch(addStatesItem(item));
};

export const removeItemFromStates = (item) => (dispatch) => {
  dispatch(removeStatesItem(item));
};

export const clearStatesList = () => (dispatch) => {
  dispatch(clearStatesItems());
};



// WEBPACK FOOTER //
// ./src/actions/statesList.js